import cx from "classnames";

import Markdown from "components/markdown/Markdown";
import Box from "ds/components/Box";

import styles from "./styles.module.css";

type MessageProps = {
  text: string;
  type: "deny" | "warn" | "info";
};

function Message({ text, type }: MessageProps) {
  return (
    <Box className={styles.item} gap="large" fullWidth align="center" padding="medium x-large">
      <span className={cx(styles.type, styles[type])} />
      <Markdown markup={text} />
    </Box>
  );
}

export default Message;
